import Pro1 from "../Projects/carz-1.png";
import Pro2 from "../Projects/electro1.png";
import Pro3 from "../Projects/gym1.png";
import ProMybook from "../Projects/mybook.png";
import ProAbnb from "../Projects/airbnb.png";
import ProGreeplanet from "../Projects/green-planet.png";
import ProJll from "../Projects/Jll.png";
import Foodish from "../Projects/foodish.png";
import Tour from "../Projects/tour.png";
import Homiq from "../Projects/homiq.png";
import Zafran from "../Projects/zafran.png";
import Knect from "../Projects/knect.png";
import Fluentoo from "../Projects/fluentoo.png";
import Tryesy from "../Projects/tryesy.png";
import Lookup from "../Projects/lookup.png";
import Savor from "../Projects/savor.png";
import Collabify from "../Projects/collabify.png";
import Decoor from "../Projects/decoor.png";
import Wallet from "../Projects/wallet.png";
import Nastech from "../Projects/nastech.png";
import NovaEv from "../Projects/novaEv.png";
import Soltra from "../Projects/soltra.png";
import Solar from "../Projects/solar.png";
import Infra from "../Projects/infra.png";
import Wanderly from "../Projects/wanderly.png";
import Jetlore from "../Projects/jetlore.png";
import Travel from "../Projects/travel.png";
import Micron from "../Projects/micron.png";

 export const ProjectsData = [
   {
     id: 17,
     title: "Jetlore",
     category: "uiux",
     description:
       "Jetlore is flight booking application home page with modern, minimalise design concept",
     img: Jetlore,
    //  dribble:
    //    "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
     liveLink:
       "https://www.figma.com/design/uPbCh79kSUPOPGPmSCFcFd/Jetlore?t=6t42XcaoYmYPyhfB-1",
   },
   {
     id: 17,
     title: "Wallet",
     category: "uiux",
     description:
       "Wallet- A Finance SAAS landing page. Toward Your Business- Manage Budgets, Forecast Cash Flow, and Optimize Every Dollar with Wallet.",
     img: Wallet,
     dribble:
       "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
     liveLink:
       "https://www.figma.com/design/tlyboiydPCVWlQ6q7svy2M/wallet---finance-SAAS-landing-page?node-id=13-90&t=2L8gQOzr2dstxL2U-1",
   },
   {
     id: 17,
     title: "Micron",
     category: "uiux",
     description:
       "A Business growth and management SAAS platform for startup to Enterprise business owner. Micron- Your Business's Best Friend: Streamline Operations, Boost Productivity, and Achieve Success with Micron.",
     img: Micron,
    //  dribble:
    //    "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
     liveLink:
       "https://www.figma.com/design/2fJehJkD3shxFv5I4BLoIr/Untitled?node-id=0-1&t=zxSANAkdpPDRECIq-1",
   },
   {
     id: 18,
     title: "Travel",
     category: "uiux",
     description:
       "Travel- makes traveling easy and comfortable. Travel design for convenient easy navigation tour and exploring the world more organised way",
     img: Travel,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
     liveLink:
       "https://www.figma.com/design/CFijZv54OlMfpd9eS7CQvs/Travel--travel-agency-landing-page?t=6t42XcaoYmYPyhfB-1",
   },
   {
     id: 18,
     title: "NovaEV",
     category: "uiux",
     description:
       "NovaEV is a modern and minimal EV landing page crafted to showcase the future of electric mobility. With strong hero visuals, smooth sections, and clear CTAs, it aims to captivate visitors and drive conversions.",
     img: NovaEv,
     dribble:
       "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
     liveLink:
       "https://www.figma.com/design/YU3IACj1cYANPug9iARJlw/NovaEV--Electric-car-landing-page?node-id=0-1&t=pZJO5gMzjc296l0j-1",
   },
   {
     id: 20,
     title: "Wanderly",
     category: "uiux",
     description:
       "Wanderly is a travel planning app that helps users discover new destinations, create itineraries, and share their travel experiences.",
     img: Wanderly,
     dribble: "https://dribbble.com/shots/26845597-Wanderly-Explore-the-world",
     liveLink:
       "https://www.figma.com/design/wqO9EDvMr6psrdOPxegUXz/Wanderly?node-id=0-1&t=FsErXwRavrt6u0xn-1",
   },
   {
     id: 1,
     title: "Foodish ",
     category: "uiux",
     description:
       " Order your favourite Foods with Foodish from top restaurants, track your order in real time, and enjoy tasty ...",
     img: Foodish,
     doc: "https://www.notion.so/Food-Delivery-app-274448e894188009b473d27388245bd0?source=copy_link",
     dribble:
       "https://dribbble.com/shots/26723882-Foodish-App-UI-Design-Simplifying-Food-Ordering",
     liveLink:
       "https://www.figma.com/design/4V0pyMCC1hVvtyzmfz1SGC/Foodish---Food-delivery-app?node-id=140-2&t=I2bXw5h8arPE9YI4-1",
   },
   {
     id: 16,
     title: "Decoor",
     category: "uiux",
     description:
       "Decoor is Home decoration services provider and products selling website. Its provide both services and products..",
     img: Decoor,
     dribble:
       "https://dribbble.com/shots/26724684-Decoor-Redefine-Your-Space-with-Modern-Minimalist",
     liveLink:
       "https://www.figma.com/design/WIUqsMIJRXBkuloqURCOuV/Decoor?node-id=19-371&t=l7HyOouLkyiRR5TP-1",
   },
   {
     id: 19,
     title: "Infra Interior",
     category: "uiux",
     description:
       "Infra is a minimalist interior design landing page designed with a clean and simple approach. Every section is built with purpose, from generous spacing to soft tones and readable typography.",
     img: Infra,
     dribble: "https://dribbble.com/shots/26844937-Infra-Interior",
     liveLink:
       "https://www.figma.com/design/RkL8JiNDZ8qeYlxTetvCMk/Infra-Interior-Design?node-id=0-1&t=FsErXwRavrt6u0xn-1",
   },
   {
     id: 2,
     title: "Homiq",
     category: "uiux",
     description:
       "User can get any home service at their doorstep with Homiq. Fast, reliable and hassle-free...",
     img: Homiq,
     doc: "https://www.notion.so/Service-Marketplace-App-250448e8941880f2ad97e9950510c16c?source=copy_link",
     liveLink:
       "https://www.figma.com/design/k58UAk8sQ4uB9T1k2rw2Hl/Homiq---Service-marketplace?node-id=71-376&t=wV1PG0eRMJFEOSvd-1",
   },
   
   {
     id: 3,
     title: "Zafran",
     category: "uiux",
     description:
       "Zafran is a complete online shopping experience including prodcut pages, cart, checkout and payment flow.",
     img: Zafran,
     dribble:
       "https://dribbble.com/shots/26720554-E-commerce-Web-Application-UI-Design",
     liveLink:
       "https://www.figma.com/design/llhe3JqEt69V07MDnU8SY5/Zafran?node-id=0-1&t=rMNIXitYnkqVEW44-1",
   },
   {
     id: 18,
     title: "Solar",
     category: "uiux",
     description:
       "Solar is a modern and minimal solar energy landing page- to highlight clean energy solutions in a visually warm and trustworthy way.",
     img: Solar,
     dribble: "https://dribbble.com/shots/26849038-Soltra-Your-energy",
     liveLink:
       "https://www.figma.com/design/e8rOz4JfybjRZDPOpafUjd/Soltra?node-id=0-1&t=dyMjDFoWJmQJJGKN-1",
   },
   {
     id: 14,
     title: "Nastech",
     category: "uiux",
     description:
       "Landing page design for Nastech, a Software Company, providing Software & Digital solution. The main goal was to transform their complex service offerings into a simple clear, trustworthy, and conversion-focused experience. ",
     img: Nastech,
     dribble:
       "https://dribbble.com/shots/26721592-Software-Company-Homepage-UI-Design",
     liveLink:
       "https://www.figma.com/design/FsFLYf97AsfapKh75TDhMc/Nastech--Software-agency?t=yCqKJE0b5UsOwH0I-1",
   },
   {
     id: 3,
     title: "Green Planet",
     category: "uiux",
     description:
       "Green Planet is an environmental conservation app that promotes eco-friendly practices and...",
     img: ProGreeplanet,
     dribble:
       "https://dribbble.com/shots/26721329-UI-Designing-for-a-Healthier-Earth",
     liveLink:
       "https://www.figma.com/design/Rf8FXpjuaEFsNHPi7VrWz7/Green-Planet?t=Xtq2lL8y13XaifqA-1",
   },
   {
     id: 4,
     title: "JII",
     category: "uiux",
     description:
       "Jll is a SAAS language learning app that helps users learn Japanese through interactive lessons...",
     img: ProJll,
     liveLink:
       "https://www.figma.com/design/zSovSJBnVdgKfz2N0WqIyP/Jll---Language-learning?t=Xtq2lL8y13XaifqA-1",
   },
   {
     id: 5,
     title: "CholoGhuri",
     category: "uiux",
     description:
       "Tour & Travel is a travel app that allows users to explore destinations, book tours, and manage their i...",
     img: Tour,
     liveLink:
       "https://www.figma.com/design/nmSSYOSioZpRhC1UOW4OOc/Tour-app?t=Xtq2lL8y13XaifqA-1",
   },
   {
     id: 6,
     title: "K'nect",
     category: "fullstack",
     description:
       "A new world social media application to have a new social world view. By creating a profile, users can share posts, like, comment, and follow...",
     img: Knect,
     liveLink: "https://knectt.netlify.app/",
     frontLinkGit: "https://github.com/amiribnjaman/mybook-frontend",
     backLinkGit: "https://github.com/amiribnjaman/mybook-backend",
   },

   {
     id: 8,
     title: "theCarz",
     category: "fullstack",
     description:
       "Car manufacture & selling Website. Users can buy cars online. They can also add, update, delete and manage their products. Admin...",
     img: Pro1,
     liveLink: "https://carz-manufacturing-site-a12.web.app/",
     frontLinkGit:
       "https://github.com/amiribnjaman/carz-manufacturing-project-client-a12",
     backLinkGit:
       "https://github.com/amiribnjaman/carz-manufacturing-project-server-a12",
   },
   {
     id: 9,
     title: "Eectro Enventory",
     category: "fullstack",
     description:
       "A full-stack inventory management web application where users can manage their products, update...",
     img: Pro2,
     liveLink: "https://electronics-inventory-a11.web.app/",
     frontLinkGit:
       "https://github.com/amiribnjaman/electroenventory-website-client-a11",
     backLinkGit:
       "https://github.com/amiribnjaman/electroenventory-website-server-a11",
   },
   {
     id: 7,
     title: "Fluentoo",
     category: "frontend",
     description:
       "Fluentoo is a language learning SAAS Platform. Where student can learn their favourite laguages and tutor can sell their course.",
     img: Fluentoo,
     liveLink: "https://fluentoo.netlify.app/",
     frontLinkGit: "https://github.com/amiribnjaman/language-learning-app",
   },
   {
     id: 15,
     title: "Collabify",
     category: "frontend",
     description:
       "Collabify is an Influencer collaboration website dashboard Frotend. Where user can find influencer by search, filter and get details about inclucers",
     img: Collabify,
     liveLink: "https://collaabify.netlify.app/",
     frontLinkGit: "https://github.com/amiribnjaman/collabify",
   },
   {
     id: 11,
     title: "Gym Trainer Service Website",
     category: "frontend",
     description:
       "A gym trainer service website where users can explore various training programs, view trainer pro...",
     img: Pro3,
     liveLink: "https://smart-gym-trainer.netlify.app/",
     frontLinkGit: "https://github.com/amiribnjaman/gym-trainer-service",
   },
   {
     id: 12,
     title: "Tryesy",
     category: "frontend",
     description:
       "Tryesy is a Digital agency landing page frotend developement. Tryesy provides uiux, web and mobile application development...",
     img: Tryesy,
     liveLink: "https://tryesy.netlify.app/",
     frontLinkGit: "https://github.com/amiribnjaman/tryesy",
   },
   {
     id: 13,
     title: "Lookup Convention",
     category: "frontend",
     description:
       "Lookup convention is event management website landing page. Its provide event booking services, prices etc.",
     img: Lookup,
     liveLink: "https://lookup-convention.netlify.app/",
     frontLinkGit: "https://github.com/amiribnjaman",
   },

   {
     id: 10,
     title: "Airbnb Home Clone",
     category: "frontend",
     description:
       "A clone of Airbnb home page. Only frontend focused. Where user can search homes, see detail...",
     img: ProAbnb,
     liveLink: "https://airbnb-home-clone.netlify.app/",
     frontLinkGit: "https://github.com/amiribnjaman/airbnb-home-clone",
   },
 ];
